export default __webpack_public_path__ + "static/icon-16-1-36466bda2b843f83372127b72c766220.png";